import { render, staticRenderFns } from "./NameForbiddenENSContainer.vue?vue&type=template&id=1e5f5a22&scoped=true&lang=html&"
import script from "./NameForbiddenENSContainer.vue?vue&type=script&lang=js&"
export * from "./NameForbiddenENSContainer.vue?vue&type=script&lang=js&"
import style0 from "./NameForbiddenENSContainer.vue?vue&type=style&index=0&id=1e5f5a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5f5a22",
  null
  
)

export default component.exports